import { useCallback } from "react";
import { CODE } from "../../utils/Constant";

interface UseIndicationInfoProps {
  getIndicationInfo: (orderGroupId: string) => Promise<any>;
}

/**
 * Custom Hook để load indication info từ các phân hệ
 * Dùng chung cho cả khám bệnh và điều trị
 */
export const useIndicationInfo = ({ getIndicationInfo }: UseIndicationInfoProps) => {

  const loadIndicationInfo = useCallback(async (orderGroupId: string) => {
    try {
      const response = await getIndicationInfo(orderGroupId);

      if (response?.data?.code === CODE.SUCCESS) {
        return response.data.data;
      }

      return null;
    } catch (error) {
      console.error("Error loading indication info:", error);
      return null;
    }
  }, [getIndicationInfo]);

  return {
    loadIndicationInfo
  };
};
